import { render } from "./LabdaqPendingResults.vue?vue&type=template&id=f179fcbc"
import script from "./LabdaqPendingResults.vue?vue&type=script&lang=js"
export * from "./LabdaqPendingResults.vue?vue&type=script&lang=js"

import "./LabdaqPendingResults.vue?vue&type=style&index=0&id=f179fcbc&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/LabdaqPendingResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f179fcbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f179fcbc', __exports__)) {
    console.log('reload')
    api.reload('f179fcbc', __exports__)
  }
  
  module.hot.accept("./LabdaqPendingResults.vue?vue&type=template&id=f179fcbc", () => {
    console.log('re-render')
    api.rerender('f179fcbc', render)
  })

}


export default __exports__